export const config = {
    //API_URL: 'http://localhost:4000',
    //API_URL: 'http://pavlosdev.aspfree.cz',
    //API_URL: 'http://localhost:51417',
    API_URL: 'https://chalupa-ostruzna.cz',
    DEBUG: false,
}

